import React, { useMemo }  from 'react'
import { useTable, useSortBy } from 'react-table'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { format } from 'date-fns'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import VisbilitySetting from './VisibilitySetting'

/**
 * 
 * @param {Integer} auditId id of the current audit
 * @param {Integer} auditUnit unit of audit, MU or QA
 * @param {Object[]} documents list of the documents for the correspondence for the current page
 * @param {[Integer]} fullDocumentsListLength length of documents list for all correspondence. documents prop is just the current page (up to 10 items).
 * @returns 
 */
const UploadedDocumentsTable = ({ auditId, auditUnit, documents, fullDocumentsListLength }) => {
 
  const columns = useMemo (() => 
    [
      { Header: 'Received Date', accessor: 'date' },
      { Header: 'Document Type' , accessor: 'type'},
      { Header: 'Document Name' , accessor: 'name'},
      { Header: 'File Name' , accessor: 'file', Cell: ({ value }) => <a href={`/lgyhub/api/audits/correspondence/${value.id}`}>{value.name}</a> },
      { Header: 'Uploaded by User' , accessor: 'user'},
      { Header: 'Visibility', accessor: 'document' , disableSortBy: true, Cell: ({ value }) => <VisbilitySetting auditId={auditId} auditUnit={auditUnit} document={value} />}
    ],
    [auditId, auditUnit]
  )
  const data = useMemo(() =>
      documents?.map(document => ({
        date: document.receivedDate ? format(document.receivedDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : '',
        type: document.documentTypeName,
        name: document.correspondenceName,
        file: {id: document.id, name: document.correspondenceFileName},
        user: document.createdByName,
        document: document,
        
      })) ?? [],
      [documents]
  )

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    rows
  } = useTable({ columns, data }, useSortBy)

return (
    <div className='audit-documents-table'>
      {documents.fetching && <LgyLoadingIcon />}
      {(!documents.fetching && documents?.length < 1) && <span>No documents found.</span>}
      {(!documents.fetching && documents && documents.length >= 1) && <div><span>{fullDocumentsListLength} Document(s)</span>
      <table {...getTableProps()}>
        <thead>
        {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? <MdKeyboardArrowDown size={18} alt='sorted descending'/>
                        : <MdKeyboardArrowUp size={18} alt='sorted ascending' />
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      </div>
    }
    </div>
  )
  
}
export default UploadedDocumentsTable
